module.exports = __webpack_public_path__ + "img/home-industry-body-3.b4722e97.png";